import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./ActionTable.css";
import heartLoading from "../../assests/heartLoading.gif";
import IncidentPieChart from "./IncidentPieChart";
import preloader from "../../assests/preloader1.gif";


const ActionTable = () => {
  // Constants
  const PAGE_SIZE = 10; // Fixed page size
  
  // Filter states
  const [selectedParentDomain, setSelectedParentDomain] = useState("");
  const [selectedDomain, setSelectedDomain] = useState("");
  const [selectedSubDomain, setSelectedSubDomain] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchValue, setSearchValue] = useState("");
  
  // Data states
  const [incidents, setIncidents] = useState([
    {
        "snowId": "INC17911307",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "9E7DB592-D1F9-4499-BE8C-74ABF4E69553",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=f35c162b933c7e10c649fdca2603d6e1"
    },
    {
        "snowId": "INC17911279",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "33DD1F1F-4AAB-492D-8A9C-73D2B742BA04",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=5ffb966f9330f6103d8afd872603d636"
    },
    {
        "snowId": "INC17911263",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "0214AFBE-06ED-499A-A5D4-1FDF5643DD41",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=1fcadaaf93f87e10c649fdca2603d6b9"
    },
    {
        "snowId": "INC17911172",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "C3756438-248A-4584-9B40-F7EBE3EFB509",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=d1381e2b93b87e10c649fdca2603d611"
    },
    {
        "snowId": "INC17911151",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "3D48ABE5-2EEB-4458-A8FE-E5DA814810AA",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=84c75a6793b87e10c649fdca2603d6c6"
    },
    {
        "snowId": "INC17911141",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "FA7F1B87-F489-4EAC-92C3-B356CB387A4A",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=b7d6d2a72f70b21071349d3bcfa4e347"
    },
    {
        "snowId": "INC17911140",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "3DF20682-866C-4FCF-86F5-AE74547CCC03",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=0856126b2fb0fa109ac9093fafa4e32c"
    },
    {
        "snowId": "INC17911134",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "9E7DB592-D1F9-4499-BE8C-74ABF4E69553",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=d68516e793787e10c649fdca2603d630"
    },
    {
        "snowId": "INC17911079",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "33DD1F1F-4AAB-492D-8A9C-73D2B742BA04",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=cf25d66f2f30b21071349d3bcfa4e394"
    },
    {
        "snowId": "INC17911071",
        "incidentDescription": "N/A",
        "incidentCategory": "Rule Breach",
        "assignedTo": "N/A",
        "status": "New",
        "resolutionPendingStatus": "5 days",
        "dataAssetId": "0214AFBE-06ED-499A-A5D4-1FDF5643DD41",
        "recordLink": "https://google.com/sp?id=incident_ticket&table=incident&view=sp&sys_id=1bf3d2a793bcb6103d8afd872603d63b"
    }
]);
  const [incidentCategories, setIncidentCategories] = useState([
    "Accuracy Breach",
    "Completeness Breach",
    "Consistency Breach",
    "Results unavailable",
    "Rule Breach",
    "Uniqueness Breach",
    "Validity Breach"
]);
  const [incidentCategoryCounts, setIncidentCategoryCounts] = useState({
    "Consistency Breach": 160,
    "Rule Breach": 3051,
    "Accuracy Breach": 162,
    "Validity Breach": 95,
    "Results unavailable": 200,
    "Uniqueness Breach": 34,
    "Completeness Breach": 27,
    "totalIncidents": 3729
});
  const [filters, setFilters] = useState({
    "parent_domains": [
      {
          "parent_domain_id": "C209762A-BCA3-4F27-9CEA-0B81F84D9AD9",
          "parent_domain": "Supply",
          "domains": [
              {
                  "domain_id": "1C56319A-FBD1-460A-A429-9821B82AF952",
                  "domain": "E2E Supply Chain",
                  "sub_domains": [
                      {
                          "sub_domain_id": "67C475B0-FD0C-4D40-BCFB-729C87C67B16",
                          "sub_domain": "Master Data",
                          "products": [
                              "SAP-AEP-Master"
                          ]
                      },
                      {
                          "sub_domain_id": "8E833E92-9B8B-419E-B2BD-7C5558A9EB31",
                          "sub_domain": "Inventory",
                          "products": [
                              "EDF-EU-Inventory",
                              "Kinaxis-EU-Inventory",
                              "SAP-AEP-Inventory"
                          ]
                      }
                  ]
              }
          ]
      },
      {
          "parent_domain_id": "A7D2789A-A43E-4FEB-A977-59F113B410BD",
          "parent_domain": "Test Parent Domain",
          "domains": [
              {
                  "domain_id": "ED294A13-6CFD-402B-990B-D8BD7E159383",
                  "domain": "Test Domain 1",
                  "sub_domains": [
                      {
                          "sub_domain_id": "D60827C4-5EC6-409E-AAB7-0943CC98C259",
                          "sub_domain": "SubDomain 1B",
                          "products": [
                              "Test_Circana_ANZ"
                          ]
                      },
                      {
                          "sub_domain_id": "AB2FD8B8-7601-4C5C-9DF0-A1FB04497C38",
                          "sub_domain": "SubDomain 1A",
                          "products": [
                              "Test_SNOW_1",
                              "Test_Product-2"
                          ]
                      }
                  ]
              }
          ]
      },
      {
          "parent_domain_id": "0CF982D0-A935-48AD-B0B7-A5CBFFD4A05F",
          "parent_domain": "One Demand",
          "domains": [
              {
                  "domain_id": "6891A9A4-EA2D-4D8A-AE46-06BDEF6E4063",
                  "domain": "Sales",
                  "sub_domains": [
                      {
                          "sub_domain_id": "E5A2C174-DD5A-4C20-B448-1E79C4F8D6F8",
                          "sub_domain": "Retailer Sales Data",
                          "products": [
                              "Circana-APAC-Retailer",
                              "Sales Consumption",
                              "Scorecard-Global",
                              "Quantium-APAC-Retailer",
                              "Efundamental-Global-Retailer",
                              "SellingPartner(AVC)-Global-Retailer"
                          ]
                      },
                      {
                          "sub_domain_id": "BCB98C37-9BB0-4FD0-B4E9-A03DC92B8B2D",
                          "sub_domain": "Field Sales Execution",
                          "products": [
                              "Roamler-EU-Field Sales",
                              "Trax-EU-Field Sales",
                              "Asseco-EU-Field Sales",
                              "Star",
                              "EDF-EU-Field Sales"
                          ]
                      }
                  ]
              }
          ]
      }
  ]
  });
  const [pagination, setPagination] = useState({
    "page": 1,
        "pageSize": 10,
        "totalCount": 3729,
        "totalPages": 373
  });
  
  // UI states
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);

  // Get all available options for each filter level
  const allParentDomains = useMemo(() => {
    if (!filters) return [];
    return filters.parent_domains || [];
  }, [filters]);

  const allDomains = useMemo(() => {
    if (!filters) return [];
    const domains = [];
    filters.parent_domains?.forEach(pd => {
      pd.domains?.forEach(domain => {
        domains.push({ ...domain, parentDomain: pd.parent_domain });
      });
    });
    return domains;
  }, [filters]);

  const allSubDomains = useMemo(() => {
    if (!filters) return [];
    const subDomains = [];
    filters.parent_domains?.forEach(pd => {
      pd.domains?.forEach(domain => {
        domain.sub_domains?.forEach(sd => {
          subDomains.push({ 
            ...sd, 
            parentDomain: pd.parent_domain,
            domain: domain.domain 
          });
        });
      });
    });
    return subDomains;
  }, [filters]);

  const allProducts = useMemo(() => {
    if (!filters) return [];
    const products = [];
    filters.parent_domains?.forEach(pd => {
      pd.domains?.forEach(domain => {
        domain.sub_domains?.forEach(sd => {
          sd.products?.forEach(product => {
            products.push({
              name: product,
              parentDomain: pd.parent_domain,
              domain: domain.domain,
              subDomain: sd.sub_domain
            });
          });
        });
      });
    });
    return products;
  }, [filters]);

  // Get filtered options based on current selections
  // Note: Parent Domain always shows all options for easy selection change
  const availableParentDomains = useMemo(() => {
    if (!filters) return [];
    return allParentDomains; // Always show all parent domains
  }, [allParentDomains]);

  const availableDomains = useMemo(() => {
    let filtered = allDomains;
    
    if (selectedParentDomain) {
      filtered = filtered.filter(d => d.parentDomain === selectedParentDomain);
    }
    if (selectedSubDomain) {
      const subDomain = allSubDomains.find(sd => sd.sub_domain === selectedSubDomain);
      if (subDomain) {
        filtered = filtered.filter(d => d.domain === subDomain.domain);
      }
    }
    if (selectedProduct) {
      const product = allProducts.find(p => p.name === selectedProduct);
      if (product) {
        filtered = filtered.filter(d => d.domain === product.domain);
      }
    }
    
    return filtered;
  }, [allDomains, allSubDomains, allProducts, selectedParentDomain, selectedSubDomain, selectedProduct]);

  const availableSubDomains = useMemo(() => {
    let filtered = allSubDomains;
    
    if (selectedParentDomain) {
      filtered = filtered.filter(sd => sd.parentDomain === selectedParentDomain);
    }
    if (selectedDomain) {
      filtered = filtered.filter(sd => sd.domain === selectedDomain);
    }
    if (selectedProduct) {
      const product = allProducts.find(p => p.name === selectedProduct);
      if (product) {
        filtered = filtered.filter(sd => sd.sub_domain === product.subDomain);
      }
    }
    
    return filtered;
  }, [allSubDomains, allProducts, selectedParentDomain, selectedDomain, selectedProduct]);

  const availableProducts = useMemo(() => {
    let filtered = allProducts;
    
    if (selectedParentDomain) {
      filtered = filtered.filter(p => p.parentDomain === selectedParentDomain);
    }
    if (selectedDomain) {
      filtered = filtered.filter(p => p.domain === selectedDomain);
    }
    if (selectedSubDomain) {
      filtered = filtered.filter(p => p.subDomain === selectedSubDomain);
    }
    
    return filtered;
  }, [allProducts, selectedParentDomain, selectedDomain, selectedSubDomain]);

  // Auto-fill parent filters when child filter is selected
  useEffect(() => {
    if (availableDomains.length === 1 && !selectedDomain) {
      setSelectedDomain(availableDomains[0].domain);
    }
  }, [availableDomains, selectedDomain]);

  useEffect(() => {
    if (availableSubDomains.length === 1 && !selectedSubDomain) {
      setSelectedSubDomain(availableSubDomains[0].sub_domain);
    }
  }, [availableSubDomains, selectedSubDomain]);

  useEffect(() => {
    if (availableProducts.length === 1 && !selectedProduct) {
      setSelectedProduct(availableProducts[0].name);
    }
  }, [availableProducts, selectedProduct]);

  // Auto-fill parent domain is handled in individual change handlers
  // since we always show all parent domains in the dropdown

  // Handler functions for smart filter selection
  const handleParentDomainChange = (value) => {
    setSelectedParentDomain(value);
    // Don't clear child selections - let them filter based on parent
  };

  const handleDomainChange = (value) => {
    setSelectedDomain(value);
    // Auto-fill parent domain if not selected
    if (!selectedParentDomain && value) {
      const domain = allDomains.find(d => d.domain === value);
      if (domain) {
        setSelectedParentDomain(domain.parentDomain);
      }
    }
  };

  const handleSubDomainChange = (value) => {
    setSelectedSubDomain(value);
    // Auto-fill parent filters if not selected
    if (value) {
      const subDomain = allSubDomains.find(sd => sd.sub_domain === value);
      if (subDomain) {
        if (!selectedParentDomain) {
          setSelectedParentDomain(subDomain.parentDomain);
        }
        if (!selectedDomain) {
          setSelectedDomain(subDomain.domain);
        }
      }
    }
  };

  const handleProductChange = (value) => {
    setSelectedProduct(value);
    // Auto-fill all parent filters if not selected
    if (value) {
      const product = allProducts.find(p => p.name === value);
      if (product) {
        if (!selectedParentDomain) {
          setSelectedParentDomain(product.parentDomain);
        }
        if (!selectedDomain) {
          setSelectedDomain(product.domain);
        }
        if (!selectedSubDomain) {
          setSelectedSubDomain(product.subDomain);
        }
      }
    }
  };

  // Fetch incidents data
  // const fetchIncidents = async (page = 1, searchOverride = undefined) => {
  //   setLoading(true);
  //   try {
  //     const params = new URLSearchParams();
      
  //     // Use searchOverride if provided, otherwise use searchValue
  //     const effectiveSearchValue = searchOverride !== undefined ? searchOverride : searchValue;
      
  //     // Only append parameters if they have values
  //     if (selectedParentDomain && selectedParentDomain.trim()) {
  //       params.append('parent_domain', selectedParentDomain);
  //     }
  //     if (selectedDomain && selectedDomain.trim()) {
  //       params.append('domain', selectedDomain);
  //     }
  //     if (selectedSubDomain && selectedSubDomain.trim()) {
  //       params.append('sub_domain', selectedSubDomain);
  //     }
  //     if (selectedProduct && selectedProduct.trim()) {
  //       params.append('product', selectedProduct);
  //     }
  //     if (effectiveSearchValue && effectiveSearchValue.trim()) {
  //       params.append('snowId', effectiveSearchValue);
  //     }
  //     if (selectedCategory && selectedCategory.trim()) {
  //       params.append('incident_category', selectedCategory);
  //     }
      
  //     // Always append page and page_size
  //     params.append('page', page);
  //     params.append('page_size', PAGE_SIZE);

  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/get-all-incidents?${params.toString()}`
  //     );

  //     if (response.data && response.data.status === 200) {
  //       setIncidents(response.data.data || []);
  //       setIncidentCategories(response.data.incidentCategories || []);
  //       setIncidentCategoryCounts(response.data.incidentCategoryCounts || {});
  //       setFilters(response.data.filters || null);
  //       // Ensure pageSize is always PAGE_SIZE
  //       setPagination({
  //         ...(response.data.pagination || pagination),
  //         pageSize: PAGE_SIZE
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching incidents:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Initial fetch
  // useEffect(() => {
  //   fetchIncidents(1);
  // }, []);

  // Refetch when filters change (excluding searchValue - search triggers on Enter key)
  // useEffect(() => {
  //   if (filters) {
  //     fetchIncidents(1);
  //   }
  // }, [selectedParentDomain, selectedDomain, selectedSubDomain, selectedProduct, selectedCategory]);

  // Handle reset trigger - fetch data when all filters are cleared
  // useEffect(() => {
  //   if (resetTrigger) {
  //     fetchIncidents(1);
  //     setResetTrigger(false);
  //   }
  // }, [resetTrigger]);

  // Handle pagination
  // const handlePageChange = (newPage) => {
  //   fetchIncidents(newPage);
  // };

  // Reset all filters and fetch data
  const resetAll = () => {
    setSelectedParentDomain("");
    setSelectedDomain("");
    setSelectedSubDomain("");
    setSelectedProduct("");
    setSelectedCategory("");
    setSearchValue("");
    // Trigger fetch with cleared filters (same as initial load)
    setResetTrigger(true);
  };

  if (loading && incidents.length === 0) {
    return (
      <div className="relative bg-white flex items-center justify-center z-50 min-h-screen">
             <div className="flex flex-col items-center space-y-3">
               <img src={preloader} alt="Loading..." width={200} />
               <span className="text-gray-700 text-[20px] text-center">
                 Loading incidents...
               </span>
             </div>
           </div>
    );
  }

  return (
    <div className="incident-wrapper space-y-6 p-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-[#bb1ccc]">Action</h1>
      </div>

      {/* Pie Chart Section */}
      <IncidentPieChart categoryCount={incidentCategoryCounts} />

      <div className="border border-gray-300 rounded-lg">

     

      {/* Filters Section */}
      <div className="bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3 flex-1">
            <input
              type="text"
              placeholder="Search by Snow ID"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:[#bb1ccc] w-64"
            />
            <button
              // onClick={() => fetchIncidents(1)}
              className="px-4 py-2 text-sm font-medium text-white bg-[#bb1ccc] rounded-lg hover:bg-[#bb1ccc]"
            >
              Search
            </button>
            {searchValue && (
              <button
                onClick={() => {
                  setSearchValue("");
                  // Trigger fetch without snowId parameter (pass empty string as searchOverride)
                  // fetchIncidents(1, "");
                }}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100"
              >
                Clear Search
              </button>
            )}
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={resetAll}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100"
            >
              Reset
            </button>
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="px-4 py-2 text-sm font-medium text-white bg-[#bb1ccc] rounded-lg hover:bg-[#bb1ccc]"
            >
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>
          </div>
        </div>

        {/* Collapsible Filters */}
        {showFilters && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 pt-4 border-t">
            {/* Parent Domain */}
            <select
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedParentDomain}
              onChange={(e) => handleParentDomainChange(e.target.value)}
            >
              <option value="">Select Parent Domain</option>
              {availableParentDomains.map((pd) => (
                <option key={pd.parent_domain_id} value={pd.parent_domain}>
                  {pd.parent_domain}
                </option>
              ))}
            </select>

            {/* Domain */}
            <select
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedDomain}
              onChange={(e) => handleDomainChange(e.target.value)}
            >
              <option value="">Select Domain</option>
              {availableDomains.map((d) => (
                <option key={d.domain_id} value={d.domain}>
                  {d.domain}
                </option>
              ))}
            </select>

            {/* Sub Domain */}
            <select
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedSubDomain}
              onChange={(e) => handleSubDomainChange(e.target.value)}
            >
              <option value="">Select Sub Domain</option>
              {availableSubDomains.map((sd) => (
                <option key={sd.sub_domain_id} value={sd.sub_domain}>
                  {sd.sub_domain}
                </option>
              ))}
            </select>

            {/* Product */}
            <select
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedProduct}
              onChange={(e) => handleProductChange(e.target.value)}
            >
              <option value="">Select Product</option>
              {availableProducts.map((product, index) => (
                <option key={index} value={product.name}>
                  {product.name}
                </option>
              ))}
            </select>

            {/* Incident Category */}
            <select
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="">Select Incident Category</option>
              {incidentCategories.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  SNOW ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Incident Description
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Incident Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Assigned to
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Resolution Pending Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                // Skeleton Loading
                [...Array(5)].map((_, index) => (
                  <tr key={index} className="animate-pulse">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="h-4 bg-gray-200 rounded w-24"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="h-4 bg-gray-200 rounded w-32"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="h-4 bg-gray-200 rounded w-28"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="h-4 bg-gray-200 rounded w-20"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="h-6 bg-gray-200 rounded-full w-20"></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="h-4 bg-gray-200 rounded w-16"></div>
                    </td>
                  </tr>
                ))
              ) : incidents.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-6 py-20">
                    <div className="flex flex-col items-center justify-center text-center">
                      <svg
                        className="w-24 h-24 text-gray-300 mb-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1.5}
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      <h3 className="text-xl font-semibold text-gray-700 mb-2">
                        No Incidents Found
                      </h3>
                      <p className="text-gray-500 max-w-md">
                        {selectedParentDomain || selectedDomain || selectedSubDomain || selectedProduct || searchValue || selectedCategory
                          ? "No incidents match the selected filters. Try adjusting your search criteria."
                          : "There are no incidents to display at the moment."}
                      </p>
                      {(selectedParentDomain || selectedDomain || selectedSubDomain || selectedProduct || searchValue || selectedCategory) && (
                        <button
                          onClick={resetAll}
                          className="mt-4 px-4 py-2 text-sm font-medium text-white bg-[#bb1ccc] rounded-lg hover:bg-[#bb1ccc]"
                        >
                          Clear All Filters
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ) : (
                incidents.map((incident, index) => (
                  <tr 
                    key={index} 
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span 
                        className="text-blue-600 font-medium hover:underline cursor-pointer"
                        onClick={() => {
                          if (incident.recordLink) {
                            window.open(incident.recordLink, '_blank', 'noopener,noreferrer');
                          }
                        }}
                        title={incident.recordLink ? "Click to view incident details" : "No record link available"}
                      >
                        {incident.snowId}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {incident.incidentDescription}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {incident.incidentCategory}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {incident.assignedTo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                        incident.status === 'Complete' ? 'bg-green-100 text-green-800' :
                        incident.status === 'In Progress' ? 'bg-yellow-100 text-yellow-800' :
                        incident.status === 'New' ? 'bg-blue-100 text-blue-800' :
                        'bg-red-100 text-red-800'
                      }`}>
                        {incident.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <span className={`${
                        incident.resolutionPendingStatus === '0 days' ? 'text-green-600' :
                        parseInt(incident.resolutionPendingStatus) <= 2 ? 'text-yellow-600' :
                        'text-red-600'
                      } font-medium`}>
                        {incident.resolutionPendingStatus}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {!loading && incidents.length > 0 && (
          <div className="bg-gray-50 px-6 py-4 flex items-center justify-between border-t">
            <div className="text-sm text-gray-700">
              Showing <span className="font-medium">{((pagination.page - 1) * PAGE_SIZE) + 1}</span> to{' '}
              <span className="font-medium">
                {Math.min(pagination.page * PAGE_SIZE, pagination.totalCount)}
              </span> of{' '}
              <span className="font-medium">{pagination.totalCount}</span> results
            </div>
            <div className="flex items-center space-x-2">
              <button
                // onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page === 1}
                className="px-3 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              <div className="flex items-center space-x-1">
                {[...Array(Math.min(5, pagination.totalPages))].map((_, i) => {
                  let pageNum;
                  if (pagination.totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (pagination.page <= 3) {
                    pageNum = i + 1;
                  } else if (pagination.page >= pagination.totalPages - 2) {
                    pageNum = pagination.totalPages - 4 + i;
                  } else {
                    pageNum = pagination.page - 2 + i;
                  }
                  
                  return (
                    <button
                      key={i}
                      // onClick={() => handlePageChange(pageNum)}
                      className={`px-3 py-1 text-sm font-medium rounded-md ${
                        pagination.page === pageNum
                          ? 'bg-[#0000a0] text-white'
                          : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>
              <button
                // onClick={() => handlePageChange(pagination.page + 1)}
                disabled={pagination.page === pagination.totalPages}
                className="px-3 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default ActionTable;